import React from 'react';
import { CheckmarkIcon } from '../../icons';
import { useSelector } from 'react-redux';
import config from '../../config';
import { RIDER_AVAILABILITY_NOT_AVAILABLE } from '../../marketplace-custom-config';
import classNames from 'classnames';
import css from './InfoItem.css';

const { userTypeRider } = config;

const InfoItem = ({ listing, isRider, content, matching }) => {
    const currentUser = useSelector(state => state.user.currentUser);
    const currentUserDefined = currentUser && currentUser.id;

    const { attributes } = listing;
    const { publicData } = attributes;
    const { userRepresentationId } = publicData;
    const isUserListing = !!userRepresentationId;

    const noMatchForRiders =
        currentUserDefined &&
        currentUser.attributes.profile.publicData.userType === userTypeRider &&
        isUserListing;

    const matchForRidersUnavailable =
        !isUserListing &&
        isRider &&
        currentUser.attributes.profile.publicData.availabilityStatus ===
            RIDER_AVAILABILITY_NOT_AVAILABLE;

    const listingMatches = !noMatchForRiders && !matchForRidersUnavailable && matching;
    return (
        <div
            className={classNames({
                [css.infoItem]: true,
                [css.infoItemMatches]: listingMatches,
            })}
        >
            {listingMatches && <CheckmarkIcon />}
            {content}
        </div>
    );
};

export default InfoItem;
